import React from 'react';
import Widget from 'components/Widget/index';
import PlaceholderSpinner from 'components/kea/placeholders/PlaceholderSpinner';
import WidgetRainbow from 'components/kea/widgets/common/WidgetRainbow';
import { analyticsChartTheme } from 'util/chartUtils';
import { useLocalizedMessage } from 'util/useLocalizedMessage';

const StatsWidget = ({ stats }) => {
  const localizeMessage = useLocalizedMessage();
  if (!stats) {
    return (
      <Widget styleName="jr-card-full noMargin">
        <PlaceholderSpinner height={129} />
      </Widget>
    );
  }
  const totalPurchases = Number(stats.userPurchase) || 0;
  const totalViews = Number(stats.totalViews) || 0;
  const conversion = Number.isFinite(Number(stats.conversion)) ? `${stats.conversion}%` : '-';

  const pieData = [
    {
      id: '1',
      name: localizeMessage('analytics.product.metrics.purchases'),
      fill: analyticsChartTheme.searches,
      value: totalPurchases,
    },
    {
      id: '2',
      name: localizeMessage('analytics.product.metrics.viewsWithoutPurchase'),
      fill: analyticsChartTheme.searchesFill,
      value: Math.max(totalViews - totalPurchases, 0),
    },
  ];

  return (
    <WidgetRainbow
      pieData={pieData}
      title={localizeMessage('analytics.product.conversion.title')}
      mainNumber={conversion}
      description={localizeMessage('analytics.product.conversion.description')}
      tone="searches"
    />
  );
};

export default StatsWidget;
